import { TileServerSettings } from "../maps/tile-server-settings";
import { LeafletMapSettings } from "../maps/leaflet-map-settings";

export class SettingsService {
  mapSettings: LeafletMapSettings;
  tileServerSettings: TileServerSettings;
  serviceUrl: string;
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/services/settings.ts